import { connect } from 'react-redux';
import KodeGuru from '../../../views/Kurikulum/MataPelajaran/KodeGuru.view.js';
import { getStudent } from '../../../states/thunks/student.thunk.js';
import { getClasses, getSubjectOptions, getClassesOptions, getStaffScheduleOptions, getStaffScheduleMoveOptions } from '../../../states/thunks/options.thunk.js';
import { listCodeTeacher, deleteListTeacher, listTeacherExcel, saveCodeTeacher, editCodeTeacher, listCodeNonTeacher } from '../../../states/thunks/academics.thunk.js';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    result: state.result,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetClasses: payload => dispatch(getClasses(payload)),
    handleGetStudent: () => dispatch(getStudent()),
    handleDeleteListTeacher: (payload, goBack) => dispatch(deleteListTeacher(payload, goBack)),
    handleListCodeTeacher: (payload, goBack) => dispatch(listCodeTeacher(payload, goBack)),
    handleListCodeNonTeacher: (payload, goBack) => dispatch(listCodeNonTeacher(payload, goBack)),
    handleSaveCodeTeacher: (payload, goBack) => dispatch(saveCodeTeacher(payload, goBack)),
    handleEditCodeTeacher: (payload, goBack) => dispatch(editCodeTeacher(payload, goBack)),
    handleListTeacherExcel: (payload, goBack) => dispatch(listTeacherExcel(payload, goBack)),
    getSubjectOptions: payload => dispatch(getSubjectOptions(payload)),
    getClassesOptions: payload => dispatch(getClassesOptions(payload)),
    getStaffScheduleOptions: payload => dispatch(getStaffScheduleOptions(payload)),
    getStaffScheduleMoveOptions: payload => dispatch(getStaffScheduleMoveOptions(payload)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(KodeGuru);
